import { api } from '@/api';

export interface FeedbackOption {
  label: string;
  value: string;
}

export interface GetChatMessageFeedbackOptionsResponse {
  reasons: FeedbackOption[];
}

const chatMessageFeedbackOptionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChatMessageFeedbackOptions: builder.query<GetChatMessageFeedbackOptionsResponse, void>({
      query: () => ({
        url: '/chat/message/feedback/options',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetChatMessageFeedbackOptionsQuery } = chatMessageFeedbackOptionsApi;
